import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { deleteItem } from "../../api/generics";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import ProductBrand from "../../models/product-brand";

interface ProductBrandDeleteModalProps {
  show: boolean;
  productBrand?: ProductBrand;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const ProductBrandDeleteModal: React.FC<ProductBrandDeleteModalProps> = ({
  show,
  productBrand,
  onCancel,
  onSuccess,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const message = productBrand
    ? `Está seguro de que quiere eliminar la marca ${productBrand.name}`
    : "";

  const onDeleteClick = async () => {
    if (productBrand !== undefined) {
      setSubmitting(true);
      const brandStatus = await deleteItem<ProductBrand>(
        `/product_brands/${productBrand.id}/`,
        productBrand
      );

      if (brandStatus.status !== SUCCESS) {
        errorAlert(
          "No se pudo eliminar la marca. Verifique que no tenga productos asignados"
        );
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-danger" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Eliminar</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onDeleteClick} color="danger">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Eliminando..." : "Eliminar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default ProductBrandDeleteModal;
